<template>
  <div class="kw-grid">
    <div v-for="w in wochen" :key="w.key" class="kw-card" :class="cardClass(w)">
      <label class="kw-head">
        <input type="checkbox" :checked="value.includes(w.key)" :disabled="!!sperrgrund(w)" @change="toggle(w.key, $event.target.checked)">
        <span>KW {{ w.nummer }}</span>
        <span class="kw-par">{{ parityText(w.paritaet) }}</span>
      </label>
      <div class="kw-date">{{ fmtDayShort(w.montag) }} – {{ fmtDay(w.sonntag) }}</div>
      <div class="kw-body">
        <b>{{ zuordnungLabel(eff(w)) }}</b>
        <small v-if="sperrgrund(w)" class="kw-block">{{ sperrgrund(w) }}</small>
        <small v-else-if="staged(w) && staged(w).vorher">vorher: {{ zuordnungLabel(staged(w).vorher) }}</small>
        <small v-else-if="staged(w)">neu vorgemerkt</small>
        <small v-else-if="eff(w) && eff(w).raster_geaendert" class="orange--text text--darken-3">Raster seit Zuordnung geändert</small>
        <small v-else>{{ eff(w) ? 'gespeichert' : 'noch keine Musterwoche' }}</small>
        <small v-for="(h, d) in holidays(w)" :key="d" class="kw-hol">{{ fmtDayShort(d) }} {{ h }}</small>
      </div>
      <div class="kw-foot">
        <v-chip x-small :color="staged(w) ? 'success' : ''" :outlined="!staged(w)" :dark="!!staged(w)">{{ staged(w) ? 'Vorgemerkt' : 'KW ' + w.nummer }}</v-chip>
        <v-spacer/>
        <v-btn v-if="staged(w)" x-small text color="primary" @click="$emit('undo', w)">Rückgängig</v-btn>
        <v-btn v-else-if="eff(w)" x-small text color="primary" @click="$emit('preview', w, eff(w))">Ansehen</v-btn>
      </div>
    </div>
  </div>
</template>

<script>
import {fmtDay, fmtDayShort, inPhase, parityText} from '@/shared/dienstplan_api'
import {dp, effZuordnung, zKey, zuordnungLabel} from '../store'

// Step 3: calendar-week cards of the planning range for one target.
export default {
  name: 'KwKarten',
  props: {
    wochen: {type: Array, required: true},
    zielTyp: {type: String, required: true},
    zielId: {type: String, default: ''},
    value: {type: Array, default: () => []}, // checked ISO weeks
    gewaehlt: {type: Object, default: null}, // selected pattern week
    paritaet: {type: String, default: 'ALL'}, // machines: ODD | EVEN | ALL
  },
  methods: {
    fmtDay,
    fmtDayShort,
    parityText,
    zuordnungLabel,
    eff (w) {
      return effZuordnung(this.zielTyp, this.zielId, w.key)
    },
    staged (w) {
      return dp.staged.zuordnungen[zKey(this.zielTyp, this.zielId, w.key)]
    },
    sperrgrund (w) {
      if (this.paritaet !== 'ALL' && w.paritaet !== this.paritaet) return 'ausgeschlossen: ' + parityText(w.paritaet) + 'e KW'
      if (this.gewaehlt && !inPhase(w.montag, this.gewaehlt.phase_von, this.gewaehlt.phase_bis)) return 'außerhalb der Phase der Musterwoche'
      return ''
    },
    holidays (w) {
      const res = {}
      for (const [d, n] of Object.entries(dp.feiertage)) {
        if (d >= w.montag && d <= w.sonntag) res[d] = n
      }
      return res
    },
    cardClass (w) {
      return {checked: this.value.includes(w.key), staged: !!this.staged(w), inactive: !!this.sperrgrund(w)}
    },
    toggle (key, on) {
      this.$emit('input', on ? [...new Set([...this.value, key])] : this.value.filter(k => k !== key))
    },
  },
}
</script>

<style scoped>
.kw-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(180px, 1fr));
  gap: 10px;
  max-height: 480px;
  overflow: auto;
  padding: 2px;
}
.kw-card {
  border: 1px solid #d0d4d8;
  border-radius: 3px;
  background: #fff;
  min-height: 140px;
  display: flex;
  flex-direction: column;
}
.kw-card.checked {
  border-color: #3f51b5;
  box-shadow: 0 0 0 1px #3f51b5;
}
.kw-card.staged {
  border-bottom: 3px solid #4caf50;
}
.kw-card.inactive {
  background: #f7f7f7;
  opacity: 0.7;
}
.kw-head {
  display: flex;
  align-items: center;
  gap: 7px;
  padding: 9px 10px 4px;
  font-weight: 600;
  cursor: pointer;
  margin: 0;
}
.kw-head input {
  accent-color: #3f51b5;
}
.kw-par {
  margin-left: auto;
  font-weight: 400;
  font-size: 11px;
  color: #757575;
}
.kw-date {
  font-size: 11px;
  color: #616161;
  padding: 0 10px 6px 30px;
}
.kw-body {
  border-top: 1px solid #eceff1;
  padding: 8px 10px;
  font-size: 12px;
  flex: 1 1 auto;
}
.kw-body b {
  display: block;
  margin-bottom: 3px;
}
.kw-body small {
  display: block;
  color: #757575;
}
.kw-body small.kw-block {
  color: #b71c1c;
}
.kw-body small.kw-hol {
  color: #c62828;
}
.kw-foot {
  display: flex;
  align-items: center;
  padding: 0 6px 6px 8px;
}
</style>
